import { setFrame } from './private/set_frame.js';

export const startFrame = async (original_frame, assign) => setFrame(original_frame, assign, $.frame);
